module.exports = __webpack_public_path__ + "97911992.png";